export const SET_PENDING_SERVICES = "getPendingServices";
export const DELETE_SERVICE = "deletePedingService";
export const SET_FILTER_PENDING_CLIENT = "setFilterPendingClient";
export const SET_DATE = "setDate";
